import { createSelector } from '@ngrx/store';
import { getConfigurationState } from 'ish-core/store/core/configuration';
import { getServerConfigParameter } from 'ish-core/store/core/server-config';
import { getDotCmsState } from '../dot-cms-store';

export const getConfigurableContentsState = createSelector(getDotCmsState, state => state.configurableContents);

const getConfigurableContentsFromEnv = (key: string) =>
  createSelector(getConfigurationState, (state: any) => state[key]);

export const getCurrentConfigurationContent = (key: string) =>
  createSelector(
    getServerConfigParameter<string>('dotcms.' + key),
    //Todo: change the footer key in environment
    getConfigurableContentsFromEnv(key),
    (serverConfig, envConfig) => (serverConfig || envConfig) as string
  );

export const getConfigurableContentletIdentifier = (key: string) =>
  createSelector(getConfigurableContentsState, state => state[key]);
